var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c(
      "section",
      { staticClass: "people-section" },
      [
        _c("header-inner"),
        _c(
          "wrapper",
          {
            staticClass: "page--top",
            attrs: { lineBorders: false, lineCenter: true }
          },
          [
            _c("about-menu", {
              on: {
                currentMenu: function($event) {
                  _vm.currentMenu($event)
                }
              }
            }),
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.peoplesloaded,
                    expression: "peoplesloaded"
                  }
                ],
                staticClass: "content-people row-grid"
              },
              _vm._l(_vm.getPeopleList, function(people) {
                return _c(
                  "div",
                  { key: people.id, staticClass: "col-md-4 col-xs-6 item" },
                  [
                    _c("div", { staticClass: "content" }, [
                      people.image
                        ? _c(
                            "div",
                            {
                              staticClass: "img",
                              on: {
                                click: function($event) {
                                  _vm.onLinkClick(people.id)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "size-2 cover",
                                attrs: { src: people.image }
                              })
                            ]
                          )
                        : _c("div", { staticClass: "img" }),
                      _c("div", {
                        staticClass: "name",
                        domProps: { innerHTML: _vm._s(people.title) }
                      }),
                      _c("div", {
                        staticClass: "prof",
                        domProps: { innerHTML: _vm._s(people.post) }
                      }),
                      _c("div", {
                        staticClass: "description",
                        domProps: { innerHTML: _vm._s(people.department) }
                      })
                    ])
                  ]
                )
              })
            ),
            _c("modal", { ref: "peopleModal", attrs: { fixedHeader: false } }, [
              this.peopleloaded
                ? _c("div", { staticClass: "people-modal" }, [
                    _c("figure", [
                      _c("img", {
                        attrs: {
                          src: this.getPeopleOne.image,
                          alt: this.getPeopleOne.title
                        }
                      }),
                      _c("figcaption", [
                        _c("h2", {
                          staticClass: "text-blue-2",
                          domProps: {
                            innerHTML: _vm._s(_vm.getPeopleOne.title)
                          }
                        }),
                        _c("div", {
                          staticClass: "post",
                          domProps: {
                            innerHTML: _vm._s(_vm.getPeopleOne.position)
                          }
                        })
                      ])
                    ]),
                    _c("article", {
                      staticClass: "people-text typography-text",
                      domProps: {
                        innerHTML: _vm._s(this.getPeopleOne.description)
                      }
                    })
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-413faecc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413faecc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/company/people.vue
// module id = RlP8
// module chunks = 29